import "./index.css";

function Saving() {
  return (
    <div className="Saving">
      <h1 style={{ color: "white" }}>Saving...</h1>
    </div>
  )
}

export default Saving;
